import { render } from "./shareCode.vue?vue&type=template&id=3a35e22a&scoped=true"
import script from "./shareCode.vue?vue&type=script&lang=js"
export * from "./shareCode.vue?vue&type=script&lang=js"

import "./shareCode.vue?vue&type=style&index=0&id=3a35e22a&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a35e22a"],['__file',"src/views/branch/staff/shareCode.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3a35e22a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3a35e22a', __exports__)) {
    console.log('reload')
    api.reload('3a35e22a', __exports__)
  }
  
  module.hot.accept("./shareCode.vue?vue&type=template&id=3a35e22a&scoped=true", () => {
    console.log('re-render')
    api.rerender('3a35e22a', render)
  })

}


export default __exports__